export default __webpack_public_path__ + "static/media/me.d114fc67.jpg";